/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

// Poor man's week start calculation based on
//     https://stackoverflow.com/questions/53382465/how-can-i-determine-if-week-starts-on-monday-or-sunday-based-on-locale-in-pure-j
// that claims to cover 99.9% of all users. Could also use 'weekstart' third party lib.
// Using below as not much downside to being in 0.1% as user calendar display will just start on wrong day (e.g., Monday instead of Sunday).
//
// Much Longer-term: Will be handled by tc39 spec: https://github.com/tc39/proposal-intl-locale-info
//    but that will be years out before our minimum browser stack supports it (assuming spec keeps progressing)

// Use regexp to break long string into array of 2 char strings (more compact representation)
import { DayOfWeek } from "abweb/utils/date/DayOfWeek";
const regionSat = "AEAFBHDJDZEGIQIRJOKWLYOMQASDSY".match(/../g); // equivalent to: ["AE", "AF", ..., "SY"]
const regionSun = "AGARASAUBDBRBSBTBWBZCACNCODMDOETGTGUHKHNIDILINJMJPKEKHKRLAMHMMMOMTMXMZNINPPAPEPHPKPRPTPYSASGSVTHTTTWUMUSVEVIWSYEZAZW".match(/../g);
const languageSat = ["ar", "arq", "arz", "fa"]; // can't use regex trick as mix of 2-char and 3-char languages
const languageSun = "amasbndzengnguhehiidjajvkmknkolomhmlmrmtmyneomorpapssdsmsnsutatethtnurzhzu".match(/../g);

/**
 *
 * @returns day index that is start of the week for given region and language.
 * Day indexes are: 0 = Sunday, 1: Monday, ... 6: Saturday
 */
function weekStart(region, language) {
  // Defaults to Monday, and above arrays handle regions (preferred) and languages that start on days other than Monday.
  return region ? regionSun.includes(region) ? DayOfWeek.SUN : regionSat.includes(region) ? DayOfWeek.SAT : DayOfWeek.MON : languageSun.includes(language) ? DayOfWeek.SUN : languageSat.includes(language) ? DayOfWeek.SAT : DayOfWeek.MON;
}

/**
 * @return day of week index (0=Sunday, ... 6: Saturday).
 * Do NOT directly use this - instead, use AbCalendarDay.firstDay()
 */
export function weekStartLocale(localeIdentifier) {
  // localeIdentifier contains language identifier (language script and region subtab) and extension tags.
  // If region provided, it is always at the end of the localeIdentifier.  See
  // https://www.google.com/search?q=locale+identifier+format&rlz=1C1CHBD_enUS885US885&oq=locale+identifier+format&aqs=chrome..69i57.3987j0j4&sourceid=chrome&ie=UTF-8
  const parts = localeIdentifier.match(/^([a-z]{2,3})(?:-([a-z]{3})(?=$|-))?(?:-([a-z]{4})(?=$|-))?(?:-([a-z]{2}|\d{3})(?=$|-))?/i);
  if (parts && parts.length >= 5) {
    return weekStart(parts[4], parts[1]);
  }
  console.error(`Unable to parse locale '${localeIdentifier}' for weekStartLocale calculation.  Returning Monday.`);
  return DayOfWeek.MON; // Monday
}
//# sourceMappingURL=WeekStart.js.map
